import { Text } from '@radix-ui/themes';
import { Gauge } from 'lucide-react';
import type { CodexUsage } from '@mac-remote/protocol';
import { mostUsed, primaryLimit, shownLimits, usedColor } from '../lib/codexLimits';

/** The main Codex usage window, with other windows available in the full panel. */
export function CodexBadge({ usage, onClick }: { usage: CodexUsage | null; onClick: () => void }) {
  const primary = usage?.ok ? primaryLimit(usage) : null;
  const others = usage?.ok ? shownLimits(usage).filter((l) => l.key !== primary?.key) : [];
  const worstOther = mostUsed(others);

  // Grey while there is room, and only then amber and red. A permanently coloured
  // number in the header is one more thing competing with what is actually happening.
  const tone = (used: number): string => {
    const c = usedColor(used);
    return c === 'jade' ? 'var(--app-hint)' : `var(--${c}-11)`;
  };
  const color = primary ? tone(primary.used) : usage && !usage.ok ? 'var(--amber-11)' : 'var(--app-hint)';
  const iconColor = worstOther && worstOther.used > (primary?.used ?? 0) ? tone(worstOther.used) : color;

  const title = usage
    ? usage.ok
      ? shownLimits(usage)
          .map((l) => `${l.title}: использовано ${Math.round(l.used)}%`)
          .join('\n') || 'Лимиты Codex'
      : usage.error
    : 'Лимиты Codex — мак не на связи';

  return (
    <button className="hbtn" onClick={onClick} title={title} style={{ color }}>
      <Gauge size={15} style={{ flex: '0 0 auto', color: iconColor }} />
      {/* The label can be a model name, which has no length guarantee — it truncates,
          the percentage never does. */}
      <Text size="1" style={{ color, maxWidth: 54, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {primary ? primary.label : usage && !usage.ok ? '?' : '—'}
      </Text>
      {primary && (
        <Text size="1" weight="medium" style={{ color, flex: '0 0 auto' }}>
          {Math.round(primary.used)}%
        </Text>
      )}
    </button>
  );
}
